/* eslint-disable react/no-danger */
export default function HeaderCityDT(props) {
  const { heading_and_searchbar: headingAndSearchBar = '' } = props?.data || {};
  return (
    <>
      <header className="newSection modify-search-header" id="orderHeader" dangerouslySetInnerHTML={{ __html: headingAndSearchBar }} />
    </>
  );
}
